import React from 'react'

export default function GlobalLoader() {

  return (
    <div className='builder-spinner-wrapper'>
      <div className='spinner'>
        <div className='double-bounce1'/>
        <div className='double-bounce2'/>
      </div>
    </div>
  )
}